import { Injectable } from "@angular/core";
import { HttpClient, HttpParams } from "@angular/common/http";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { PageModel } from "@app/models/page.model";
import { FieldOption, SupplyResponse } from "@app/ui_models/web-response";
import { env } from "@environments/environment";

@Injectable({ providedIn: "root" })
export class SupplyController {

  public constructor(httpService: HttpClient) {
    this.httpService = httpService;
  }

  httpService: HttpClient;

  public getEntitiesById(supplyId: string): Observable<any>  {
    const params: HttpParams = this.makeParams(supplyId);
    return this.httpService.get("/logistics/v1/supplies", { params, responseType: "text" }).pipe(map(res => (res ? JSON.parse(res) : undefined)));
  }

  public searchSuppliers(params: HttpParams): Observable<PageModel<SupplyResponse>>  {
    return this.httpService.get(env.logisticsServiceBackend + "/logistics/v1/supplies/all", { params, responseType: "text" }).pipe(map(res => (res ? JSON.parse(res) : undefined)));
  }

  public getComponents(supplyId: string): Observable<any>  {
    const params: HttpParams = this.makeParams(supplyId);
    return this.httpService.get(env.logisticsServiceBackend + "/logistics/v1/supplies/components", { params, responseType: "text" }).pipe(map(res => (res ? JSON.parse(res) : undefined)));
  }

  public getAllFilterOptions(): Observable<any>  {
    const params: HttpParams = new HttpParams();
    return this.httpService.get(env.logisticsServiceBackend + "/logistics/v1/supplies/filter/options", { params, responseType: "text" }).pipe(map(res => (res ? JSON.parse(res) : undefined)));
  }

  private makeParams(supplyId: string) {
    const queryParamsList: { name: string; value: string; }[] = [];
    queryParamsList.push({ name: "supplyId", value: supplyId });
    let params = new HttpParams();
    for (let i = 0; i < queryParamsList.length; i++) {
      const queryParam = queryParamsList[i];
      params = params.append(queryParam.name, queryParam.value);
    }
    return params;
  }
}
